export function formatMaintenanceWindow(start: Date, end: Date) {
  const locale = typeof navigator !== 'undefined' ? navigator.language : 'en-US'

  const timeZone =
    typeof Intl !== 'undefined' ? Intl.DateTimeFormat().resolvedOptions().timeZone : undefined

  const dateFormatter = new Intl.DateTimeFormat(locale, {
    weekday: 'long',
    month: 'long',
    day: 'numeric',
    year: 'numeric',
  })

  const timeFormatter = new Intl.DateTimeFormat(locale, {
    hour: 'numeric',
    minute: '2-digit',
    timeZoneName: 'short',
  })

  return {
    date: dateFormatter.format(start),
    startTime: timeFormatter.format(start),
    endTime: timeFormatter.format(end),
    timeZone,
  }
}

// Check if the user's current time is within the maintenance window
export function isWithinMaintenanceWindow(start: Date, end: Date) {
  const now = new Date()
  return now >= start && now <= end
}

export function isPastMaintenanceWindow(start: Date, end: Date) {
  const now = new Date()
  return now >= end
}

// Source of truth for the maintenance window start and end times
// modify these to change the maintenance window as needed
export const MAINTENANCE_WINDOW_START_TIME = new Date('2026-10-27T07:00:00-06:00')
export const MAINTENANCE_WINDOW_END_TIME = new Date('2026-10-27T07:30:00-06:00')
